import { LoadingContainer, LoadingContext, LoadingContextValue } from '@pokemon/design.ui.loading-spinner'
import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PTCSAddressForm } from './ptcs_address_form'
import { Form } from 'react-final-form'
import { FormApi } from 'final-form'
import { AuthContext, AuthContextValue } from '../../utils/auth/context'
import { Grid } from '@pokemon/design-v2.grid'
import { Button } from '@pokemon/design-v2.button'
import { changeProfile, ChangeProfileAddressPayload } from '../../utils/tamApi'
import { Callout } from '@pokemon/design.ui.containers.callout'
import { BaseContentBox } from '@pokemon/design.ui.containers.base-content-box'

export interface ChangeAddressPageProps {
    setError: () => void
    getLoggedUserProfile: (childGuid: string | undefined) => void
}

export function ChangeAddressPage ({ setError, getLoggedUserProfile }: ChangeAddressPageProps) {
  const { t } = useTranslation()

  const { loggedUserProfile, accessToken, selectedAccount, isChildView } = useContext<AuthContextValue>(AuthContext)

  const { setLoading } = useContext<LoadingContextValue>(LoadingContext)

  const [showSuccess, setShowSuccess] = useState(false)

  let childGuid : undefined | string
  if (isChildView) {
    childGuid = selectedAccount?.guid
  }

  const onSubmit = async (values: ChangeProfileAddressPayload, form: FormApi<ChangeProfileAddressPayload, {
    address1: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    postal_code: string | undefined;
  }>) => {
    setLoading(true)
    try {
      await changeProfile(accessToken!.token, {
        address: values
      }, childGuid)
      setShowSuccess(true)
    } catch (error: any) {
      if (error?.response?.status === 400) {
        // this is where we'd add contignency error handling if we ever decide it's worthwhile
        console.error('Something was missed in synchronous validation')
      }
      setError()
    } finally {
      setLoading(false)
    }
  }

  return <LoadingContainer altText={t('loading_spinner', 'Loading...')}>
         <BaseContentBox autoSizeBox={true} customWidth={700} title={<div className='title'>{t('change_address_form.title', 'Change Address')}</div>}>
            <Grid
            >
                <Grid marginBottom={16 / 8}>
                    {showSuccess
                      ? <Callout data-testid="address-updated-callout" variant='success'>{t('address_updated', 'Address successfully updated!')}</Callout>
                      : undefined}
                </Grid>
                <Form
                    onSubmit={onSubmit}
                    render={({ handleSubmit, valid }) => {
                      return <form onSubmit={handleSubmit}>
                                <PTCSAddressForm />
                                <Grid xs={12} marginTop={48 / 8}>
                                    <Button
                                        data-testid="address-submit-button"
                                        fullWidth
                                        type="submit"
                                        disabled={!valid}
                                    >
                                        {t('save_button', 'Save')}
                                    </Button>
                                </Grid>
                            </form>
                    }}
                    initialValues={{
                      address1: loggedUserProfile?.address?.address1,
                      address2: loggedUserProfile?.address?.address2,
                      city: loggedUserProfile?.address?.city,
                      state: loggedUserProfile?.address?.state,
                      postal_code: loggedUserProfile?.address?.postal_code
                    }}
                />
            </Grid>
        </BaseContentBox>
    </LoadingContainer>
}
